<template>
  <div>
    <b-modal
      id="modal-recruit-task"
      ref="modal_recruit_task"
      :title="title"
      content-class="modal-fullscreen"
      body-class="modal-body-fullscreen"
      lazy
      centered
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      @hidden="onHidden"
    >
      <b-skeleton-wrapper :loading="isBusy">
        <template #loading>
          <b-form>
            <b-card bg-variant="light">
              <b-row class="mt-2 mb-2">
                <b-col cols="xl">
                  <b-skeleton width="4%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col cols="5">
                  <b-skeleton width="31%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
                <b-col cols="5">
                  <b-skeleton width="18%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
                <b-col cols="auto" class="ml-auto mr-5">
                  <b-skeleton width="180%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="200%" height="44%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col cols="5">
                  <b-skeleton width="11%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
                <b-col cols="7" class="pt-2 d-flex justify-content-end align-items-center">
                  <b-skeleton type="input" width="18%" height="50%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col cols="5">
                  <b-skeleton width="13%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
                <b-col cols="5">
                  <b-skeleton width="19%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col cols="5">
                  <b-skeleton width="6%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
                <b-col cols="5">
                  <b-skeleton width="8%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
                <b-col cols="2">
                  <b-skeleton width="67%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row class="mb-4">
                <b-col>
                  <b-skeleton width="10%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="100%"/>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col class="d-flex justify-content-end align-items-end">
                  <b-skeleton type="input" width="12%" height="80%"/>
                </b-col>
              </b-row>
            </b-card>
          </b-form>
        </template>

        <template #default>
          <b-form>
            <b-card bg-variant="light">
              <b-form-group id="group-location-select" label="Объект">
                <location-select
                  ref="location_select"
                  :is-disabled="isDisabled || isIntegrated"
                  :value="newItem.location_id"
                  :initial-text="newItem.location_name"
                  @onSelect="onLocationChange"
                />
              </b-form-group>
              <b-row>
                <b-col cols="5">
                  <b-form-group id="group-opened-date" label="Дата открытия вакансии">
                    <b-form-input
                      size="sm"
                      type="date"
                      :disabled="isDisabled"
                      :placeholder="$t('message.tasks.modal.start_datePlaceholder')"
                      v-model.date="newItem.opened_date"
                      :state="getFieldState('opened_date')"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="5">
                  <b-form-group id="group-closed-date" label="Дата закрытия">
                    <b-form-input
                      size="sm"
                      type="date"
                      :disabled="isDisabled"
                      v-model.date="newItem.closed_date"
                      :state="getFieldState('closed_date')"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="2" lg="2" md="3" sm="3" class="d-flex justify-content-end">
                  <b-form-group
                    id="group-urgency"
                    label="Срочно"
                  >
                    <b-card no-body class="px-2 pb-1 border-grey">
                      <b-form-checkbox
                        v-model="newItem.urgency"
                        :disabled="isDisabled"
                        size="md"
                        name="urgency-checkbox"
                        class="mt-1"
                      >
                        {{ newItem.urgency ? 'Да' : 'Нет' }}
                      </b-form-checkbox>
                    </b-card>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="d-flex align-items-end">
                <b-col cols="5">
                  <b-form-group id="group-location-vacancy-select" label="Вакансия">
                    <location-vacancy-select
                      ref="location_vacancy_select"
                      :is-disabled="isDisabled"
                      :location-id="newItem.location_id"
                      :location-name="newItem.location_name"
                      :value="newItem.location_vacancy_id"
                      :initial-text="newItem.location_vacancy_name"
                      :state="getFieldState('location_vacancy_id')"
                      @onSelect="onVacancyChange"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-end">
                  <b-button
                    v-b-toggle.collapse-vacancy-table
                    variant="outline-primary"
                    size="sm"
                    class="mb-3"
                    :disabled="!newItem.location_vacancy_id"
                  >
                    <font-awesome-icon :icon="isVacancyOpen ? 'chevron-up' : 'chevron-down'" class="mr-1"/>
                    {{ isVacancyOpen ? 'Скрыть вакансию' : 'Показать вакансию' }}
                  </b-button>
                </b-col>
              </b-row>

              <b-collapse id="collapse-vacancy-table" v-model="isVacancyOpen">
                <b-card no-body class="mb-2">
                  <location-vacancies
                    ref="recruit_vacancy"
                    show-details
                    :is-disabled="isDisabled"
                    :all-fields-required="true"
                    :local-items="[newItem]"
                    @close="isVacancyOpen = false"
                  />
                </b-card>
              </b-collapse>

              <b-row class="align-items-end">
                <b-col cols="5">
                  <b-form-group id="group-members" label="Участники">
                    <user-multi-select
                      ref="members_select"
                      :is-disabled="noLocationDisabled"
                      :user-items="locationUsers"
                      :value="newItem.members"
                      @onSelect="onMembersSelect"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="5">
                  <b-form-group id="group-assigned" label="Ответственный">
                    <b-form-select
                      size="sm"
                      :disabled="noLocationDisabled"
                      v-model="newItem.assigned"
                      :options="assignedOptions"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end">
                  <b-button
                    v-b-toggle.collapse-contacts-table
                    variant="outline-primary"
                    size="sm"
                    class="mb-3"
                    :disabled="!newItem.location_vacancy_id"
                  >
                    <font-awesome-icon :icon="isContactsOpen ? 'chevron-up' : 'chevron-down'" class="mr-1"/>
                    {{ isContactsOpen ? 'Скрыть контакты' : 'Показать контакты' }}
                  </b-button>
                </b-col>
              </b-row>

              <b-collapse id="collapse-contacts-table" v-model="isContactsOpen">
                <b-card no-body class="mb-2">
                  <location-contacts
                    ref="recruit_contacts"
                    :is-disabled="isDisabled"
                    @close="isContactsOpen = false"
                  />
                </b-card>
              </b-collapse>

              <b-row>
                <b-col cols="4" lg="5" md="4" sm="4">
                  <b-form-group label="Теги">
                    <recruit-tag-multi-select
                      :value="newItem.tags"
                      :is-disabled="isDisabled"
                      @onSelect="onTagsSelected"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="4" lg="5" md="5" sm="5">
                  <b-form-group id="group-status" label="Статус">
                    <b-form-select
                      size="sm"
                      :disabled="isDisabled"
                      v-model="newItem.status"
                      :options="statusOptions"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="2">
                  <b-form-group id="group-budget" label="Рекламный бюджет">
                    <b-form-input
                      type="number"
                      size="sm"
                      :disabled="isDisabled"
                      placeholder="Введите планируемый бюджет"
                      v-model.number="newItem.budget"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-form-group id="group-comment" label="Комментарий">
                <b-form-textarea
                  size="sm"
                  :disabled="isDisabled"
                  :placeholder="$t('message.organizations.modal.descriptionPlaceholder')"
                  v-model="newItem.comment"
                  :rows="3"
                  :max-rows="6"
                />
              </b-form-group>
              <b-row class="align-items-end">
                <b-col cols="12" class="d-flex justify-content-end">
                  <b-button
                    v-b-toggle.collapse-media
                    variant="outline-primary"
                    size="sm"
                    class="mb-3"
                    :disabled="!newItem.location_id"
                  >
                    <font-awesome-icon :icon="isMediaOpen ? 'chevron-up' : 'chevron-down'" class="mr-1"/>
                    {{ isMediaOpen ? 'Скрыть медифайлы' : 'Показать медиафайлы' }}
                  </b-button>
                </b-col>
              </b-row>

              <b-collapse id="collapse-media" v-model="isMediaOpen">
                <b-card no-body class="mb-2">
                  <location-passport
                    ref="recruit_media"
                    :location-id="newItem.location_id"
                    :is-disabled="isDisabled"
                    @close="isMediaOpen = false"
                  />
                </b-card>
              </b-collapse>
            </b-card>
          </b-form>
        </template>
      </b-skeleton-wrapper>

      <template>
        <div class="w-100 d-flex justify-content-end py-2">
          <b-button v-if="canEditRecruitJobPostings" size="sm" variant="info" @click="handleJobPosting">
            <font-awesome-icon icon="search-plus" class="mr-1"/>
            Создать объявление
          </b-button>
          <b-button size="sm" variant="secondary" class="ml-auto mr-1" @click="handleCancel">
            Отменить
          </b-button>
          <b-button size="sm" variant="success" :disabled="loading || isDisabled" @click="handleOk">
            <b-spinner v-if="loading" small/>
            <font-awesome-icon icon="save" class="mr-1"/>
            Сохранить
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import recruitTasks from "../../network/recruitTasks";
import locations from "../../network/locations";
import users from "../../network/users";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
  import permissions, {PERM} from "../../utilites/permissions";
    import LocationSelect from "../Locations/LocationSelect.vue";
    import LocationVacancySelect from "../Locations/LocationVacancySelect.vue";
    import UserMultiSelect from "../Users/UserMultiSelect.vue";
    import LocationVacancies from "../Locations/LocationVacancies.vue";
    import RecruitTagMultiSelect from "../Catalogs/RecruitTags/RecruitTagMultiSelect.vue";
    import LocationPassport from "../Locations/LocationPassport.vue";
import LocationContacts from "../Locations/LocationContacts.vue";

export default {
  name: 'RecruitTask',
  components: { LocationContacts, RecruitTagMultiSelect, LocationPassport, UserMultiSelect, LocationVacancySelect, LocationSelect, LocationVacancies },
  mixins: [
    recruitTasks, locations, users,
    helpers, dateFormatter, permissions
  ],
  props: {
    isIntegrated: { type: Boolean, default: false },
    locationId: { type: Number, default: null },
    locationName: { type: String, default: null },
  },
  data() {
    return {
      title:'Заявка на подбор',
      newItem: this.setNewItem(),
      locationUsers: [],
      statusOptions: [
        { value: 'created', text: 'Создана' },
        { value: 'assigned', text: 'Назначен рекрутер' },
        { value: 'in_progress', text: 'В работе' },
        { value: 'done', text: 'Готова' },
        { value: 'canceled', text: 'Отменена' }
      ],
      validated: true,
      isDisabled: true,
      isBusy: false,
      loading: false,
      isVacancyOpen: true,
      isMediaOpen: true,
      isContactsOpen: true,
    }
  },
  computed: {
    assignedOptions() {
      if (!this.locationUsers || this.locationUsers.length === 0) return [];

      return this.locationUsers.map(u => ({
        value: u.id,
        text: u.name + ` (${u.role_name})`
      }));
    },
    noLocationDisabled() {
      return this.isDisabled || !this.newItem.location_id;
    },
  },
  watch: {
    locationId: {
      handler(newValue) {
        if (newValue) {
          this.newItem.location_id = newValue;
        }
      }, immediate: true
    },
    locationName: {
      handler(newValue) {
        if (newValue) {
          this.newItem.location_name = newValue;
        }
      }, immediate: true
    }
  },
  methods: {
    setNewVacancy() {
      return {
        workers_count: null,
        duties: '',
        sex: '',
        age_from: null,
        age_to: null,
        citizenships: [],
        criminal_record: false,
        criminal_record_comment: '',
        work_exp: '',
        expectations: '',
        physical_work: false,
        physical_work_comment: '',
        medical_book: false,
        medical_book_comment: '',
        certificates: '',
        driver_license_categories: [],
        employment: '',
        employment_types: [],
        employment_categories: [],
        schedule: '',
        schedule_time_of_day: [],
        night_coefficient: '',
        output_format: [],
        shift_hours: '',
        break_hours: '',
        work_rate: '',
        salary: null,
        salary_smz: null,
        salary_hand: false,
        salary_hand_comment: '',
        payment_period: '',
        probation: '',
        compensation: '',
        meals: '',
        accommodation: '',
        brigadier_bonus: '',
        uniform: '',
        wardrobe: '',
        indoor_conditions: '',
        transport: '',
        corp_transport: false,
        corp_transport_comment: '',
        security_service: false,
        security_service_comment: '',
        access_mode: false,
        access_mode_comment: '',
        prohibited: '',
        text: ''
      }
    },
    setNewItem() {
      return {
        id: 0,
        location_id: null,
        location_name: '',
        location_vacancy_id: 0,
        location_vacancy_name: '',
        opened_date: null,
        closed_date: null,
        comment: '',
        contact: '',
        budget: null,
        status: 'created',
        assigned: 0,
        members: [],
        urgency: false,
        tags: [],
        ...this.setNewVacancy()
      };
    },
    onTagsSelected(selectedTags) {
      this.newItem.tags = selectedTags;
    },
    async showModal(recruitTaskId, isView) {
      this.isDisabled = isView;
      this.newItem = this.setNewItem();

      if (this.locationId) {
        this.newItem.location_id = this.locationId;
      }

      if (this.locationName) {
        this.newItem.location_name = this.locationName;
      }

      this.locationUsers = [];
      this.$refs.modal_recruit_task.show();

      if (recruitTaskId) {
        await this.getRecruitTask(recruitTaskId);
      } else if (this.newItem.location_id) {
        await this.getLocationUsers(this.newItem.location_id);
      }

      this.$nextTick(() => {
        if (this.$refs.recruit_contacts && this.newItem.location_id) {
          this.$refs.recruit_contacts.configure(this.newItem.location_id);
        }
      });
    },
    hideModal() {
      this.$refs.modal_recruit_task.hide();
    },
    handleOk() {
      this.handleSubmit();
    },
    handleCancel() {
      this.hideModal();
    },
    onHidden() {
      this.$emit('modal-closed');
      this.locationUsers = [];
    },
    async getRecruitTask(recruitTaskId) {
      this.isBusy = true;
      this.loading = true;

      const result = await this.getRecruitTaskById(recruitTaskId);

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.isBusy = false;
        this.loading = false;
        return;
      }

      this.newItem = result.data;

      this.newItem.members = this.newItem.members ? this.newItem.members.map(m => m.user_id) : [];
      this.newItem.opened_date = this.formattedFromServerDate(this.newItem.opened_date);
      this.newItem.closed_date = this.formattedFromServerDate(this.newItem.closed_date);

      await this.getLocationUsers(this.newItem.location_id);

      // если удалили сотрудника из объекта
      const assignedId = this.newItem.assigned;
      const isAssignedInLocationUsers = this.locationUsers.some(user => user.id === assignedId);

      if (assignedId && !isAssignedInLocationUsers) {
        const assignedResult = await this.getUserById(assignedId);
        if (assignedResult.data) {
          this.locationUsers.push(assignedResult.data);
        }
      }

      this.isBusy = false;
      this.loading = false;

      this.$nextTick(() => {
        if (this.$refs.recruit_vacancy) {
          this.$refs.recruit_vacancy.configure(
            this.newItem.location_id,
            this.newItem.location_name,
            this.newItem.location_vacancy_id
          );
        }
      });
    },
    async getLocationUsers(locationId) {
      if (!locationId) {
        this.locationUsers = [];
        return;
      }

      const location = await this.getLocationById(locationId);

      if (location && location.data) {
        const uniqueUserIds = [...new Set(location.data.location_users.map(item => item.user_id))];
        const promises = uniqueUserIds.map(id => this.getUserById(id));
        const result = await Promise.all(promises);

        this.locationUsers = result.map(res => res.data)
      } else {
        this.locationUsers = [];
      }
    },
    async handleSubmit() {
      const submitValidation = [
        { item: 'location_vacancy_id', message: 'Выберите вакансию.' },
        { item: 'opened_date', message: 'Выберите дату открытия.' },
        { item: 'closed_date', message: 'Выберите дату закрытия.' },
        { item: 'status', message: 'Выберите статус.' },
      ];

      for (const validation of submitValidation) {
        if (!this.newItem[validation.item]) {
          this.showSubmitError(validation.message);
          return;
        }
      }

      const vacancyItems = Object.keys(this.setNewVacancy());

      for (const key of vacancyItems) {
        const value = this.newItem[key];

        if (key === 'text') continue;

        if (key.includes('_comment')) {
          const parentCheckboxKey = key.replace('_comment', '');
          if (this.newItem[parentCheckboxKey] === false) {
            continue;
          }
        }

        let isEmpty = false;

        if (Array.isArray(value)) {
          isEmpty = value.length === 0;
        } else if (typeof value === 'boolean') {
          isEmpty = false;
        } else {
          isEmpty = value === null || value === undefined || String(value).trim() === '';
        }

        if (isEmpty) {
          this.showSubmitError(`Пожалуйста, заполните все поля вакансии.`);
          return;
        }
      }

      this.loading = true;
      const data = { ...this.newItem };

      data.members = data.members.map(userId => ({ user_id: userId }));
      data.tags = data.tags.map(tag => ({ id: tag.id }));
      data.opened_date = this.formattedToServerDate(data.opened_date);
      data.closed_date = this.formattedToServerDate(data.closed_date);

      const method = (data.id > 0) ? this.putRecruitTask : this.postRecruitTask;
      const result = await method(data);

      if (!result.data) {
        this.showError("Не удалось сохранить данные.");
        this.loading = false;
        return;
      }

      if (this.$refs.recruit_contacts && this.newItem.location_id) {
        await this.$refs.recruit_contacts.saveContacts(this.newItem.location_id)
          .catch(error => {
            this.showError("Ошибка при сохранении контактов.");
          });
      }

      this.newItem.id = result.data.id;
      this.loading = false;
      this.$emit('refresh');
      this.hideModal();
    },
    async onLocationChange(locationId) {
      if (locationId === this.newItem.location_id) return;

      this.newItem.location_id = locationId;

      Object.assign(this.newItem, this.setNewVacancy());
      this.newItem.location_vacancy_id = 0;
      this.newItem.location_vacancy_name = '';
      this.newItem.assigned = null;
      this.newItem.members = [];
      this.locationUsers = [];

      if (locationId === 0) {
        this.newItem.location_name = '';

        if (this.$refs.recruit_contacts) {
          this.$refs.recruit_contacts.items = [];
        }

        return;
      }

      if (this.$refs.location_select) {
        const selectedLocation = this.$refs.location_select.items.find(l => l.id === locationId);
        if (selectedLocation) this.newItem.location_name = selectedLocation.name;
      }

      this.loading = true;
      await this.getLocationUsers(locationId);

      if (this.$refs.recruit_contacts) {
        this.$refs.recruit_contacts.configure(locationId);
      }

      this.loading = false;
    },
    onVacancyChange(vacancy) {
      if (!vacancy) {
        this.newItem.location_vacancy_id = 0;
        this.newItem.location_vacancy_name = '';
        this.isVacancyOpen = false;
        Object.assign(this.newItem, this.setNewVacancy());

        return;
      }

      this.newItem.location_vacancy_id = vacancy.id;
      this.newItem.location_vacancy_name = vacancy.vacancy_name;

      const {
        id, location_id, location_name, create_date, update_date, active, author,
        ...templateFields
      } = vacancy;

      this.newItem = {
        ...this.newItem,
        ...templateFields
      };
    },
    onMembersSelect(selectedItems) {
      this.newItem.members = selectedItems.map(u => u.id);
    },
    handleJobPosting() {
      if (!this.newItem.id) {
        this.showError("Сначала сохраните заявку.");
        return;
      }

      this.$router.push({
        name: 'RecruitJobPostings',
        params: {
          recruitTaskId: this.newItem.id,
          recruitTaskDisabled: true
        }
      });
    },
    // Permissions
    canEditRecruitJobPostings() {
      return this.hasPermission([PERM.RECRUIT_JOB_POSTING_EDIT]);
    },
    // Validation
    getFieldState(field) {
      if (!this.validated) return null;
      return !!this.newItem[field];
    },
  }
}
</script>

<style>
#modal-recruit-task .modal-dialog {
  max-width: 100% !important;
  max-height: 100% !important;
  height: 100% !important;
  margin: 0 !important;
}

.modal-fullscreen {
  max-height: 100% !important;
  height: 100% !important;
}

.modal-body-fullscreen {
  padding-bottom: 0  !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Recruiting/RecruitTask.vue